const personalAreaStyle = Object.freeze({
  mobileMargin: Object.freeze({
    sectionMargin: '2rem',
    inBlockMargin: '3rem',
  }),
  inputStyle: ({ theme, }) => ({
  }),
  mainHeaderAccount: Object.freeze({
    fontWeight: '500',
    extend: ({ theme, }) => ([
      theme.type(7, { untilBp: 'm', }),
      theme.type(6, { fromBp: 'm', }),
    ]),
    textTransform: 'normal',
  }),
  creditCard: Object.freeze({
    linkColor: 'secondary',
  }),
  navigationBar: Object.freeze({
    linkColor: 'neutral',
  }),
  password: Object.freeze({
    buttonColor: 'secondary',
  }),
  resetPasswordText: Object({
    size: ({ theme, }) => theme.type(-1, { from: 'm', }),
  }),
  resetPasswordModal: Object.freeze({
    buttonVariant: 'secondary',
  }),
  subscription: Object.freeze({
    manageButtonVariant: 'neutralOpaque',
    cancellationButtonColor: 'secondary',
    reasonStage: Object.freeze({
      titleColor: 'secondary',
      buttonVariant: 'neutralOpaque',
      linkColor: 'secondary',
    }),
    confirmationStage: Object.freeze({
      titleColor: 'secondary',
      rightButtonVariant: 'neutralOpaque',
      leftButtonVariant: 'neutral',
    }),
    forceCancelLinkColor: 'secondary',
    standbyAngle: '0deg',
  }),
  subscriptionAndroid: Object.freeze({
    titleColor: 'secondary',
    linkColor: 'secondary',
  }),
  subscriptionApple: Object.freeze({
    titleColor: 'secondary',
    linkColor: 'secondary',
  }),
  support: Object.freeze({
    linkColor: 'secondary',
  }),
  personalAreaBlock: Object.freeze({
    buttonVariant: 'neutralOpaque',
    buttonSize: {
      paddingTop: '0.75rem',
    },
  }),
  getGridTemplateAreas: count => {
    let valueM = '';
    let valueXl = '';

    for (let i = 0; i < Math.floor(count / 4); i += 3) {
      valueM += `"radio${i} radio${i + 1} radio${i + 2}"`;
    }

    for (let i = 0; i < Math.floor(count / 3); i += 4) {
      valueXl += `"radio${i} radio${i + 1} radio${i + 2} radio${i + 3}"`;
    }

    return {
      m: valueM,
      xl: valueXl,
    };
  },
  monthCalButton: Object.freeze({
    firstBorderRadius: '0rem 2rem 2rem 0rem',
    secondBorderRadius: '2rem 0rem 0rem 2rem',
  }),
});

export default personalAreaStyle;
